import { Layout, Page } from "@fdoh/health-ui-react";
import { useHistory, useLocation } from "react-router-dom";
import FillExcavationMaterialForm from "../Components/FillExcavationMaterialForm";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";

const CreateFillExcavationMaterialPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
  return applicationId ? (
    <Page.Container>
      <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <FillExcavationMaterialForm
            id="FillExcavationMaterialForm"
            title="Fill Excavation Materials Inspection"
            action="post"
                      applicationId={applicationId ? applicationId : 0}
                      applicationInspectionId={inspectionId ? inspectionId : 0}
                      returnPath={`/inspectionDetails/${inspectionId}`}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default CreateFillExcavationMaterialPage;